// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   Kubersetu Infotech - Homepage Layout & Components
   ========================================== */

.fintech-home {
  width: 100%;
  padding-top: 5rem;
  overflow-x: hidden;
}

.fintech-container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1.5rem;
}

.w-full {
  width: 100%;
}

.text-amber {
  color: var(--color-amber) !important;
}

/* ===== Section Header Common ===== */
.section-header-center {
  text-align: center;
  max-width: 700px;
  margin: 0 auto 3.5rem;
}

.section-eyebrow {
  display: inline-block;
  font-size: 0.85rem;
  font-weight: 800;
  letter-spacing: 0.15em;
  color: var(--color-amber);
  background: transparent;
  border: none;
  padding: 0.2rem 0;
  margin-bottom: 1rem;
  text-transform: uppercase;
}

.section-header-center h2 {
  font-size: clamp(2rem, 3.5vw, 2.75rem);
  margin-bottom: 1rem;
  font-weight: 800;
}

.section-header-center p {
  color: var(--text-muted);
  font-size: 1.1rem;
  line-height: 1.6;
}

/* ===== Hero Section & Live Calculator ===== */
.hero-background-shapes {
  position: absolute;
  inset: 0;
  overflow: hidden;
  z-index: 0;
  pointer-events: none;
}

.glow-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(120px);
  opacity: 0.4;
}

.hero-background-shapes .orb-1 {
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, rgba(245, 158, 11, 0.2) 0%, transparent 70%);
  top: -20%;
  left: -10%;
}

.hero-background-shapes .orb-2 {
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(59, 130, 246, 0.15) 0%, transparent 70%);
  bottom: 10%;
  right: -5%;
}

.fintech-hero {
  padding: 0 0 5rem;
  position: relative;
}

.hero-grid {
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 3rem;
  align-items: center;
}

@media (max-width: 1024px) {
  .hero-grid {
    grid-template-columns: 1fr;
    gap: 2.5rem;
  }
}

.hero-content {
  display: flex;
  flex-direction: column;
}

.trust-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  background: transparent;
  border: none;
  padding: 0.2rem 0;
  font-size: 0.85rem;
  font-weight: 700;
  color: #FBBF24;
  margin-bottom: 1.5rem;
  width: fit-content;
}

.pill-dot {
  width: 8px;
  height: 8px;
  background: #10B981;
  border-radius: 50%;
  box-shadow: 0 0 10px #10B981;
}

.hero-title {
  font-size: clamp(2.5rem, 4.5vw, 3.75rem);
  line-height: 1.15;
  margin-bottom: 1.25rem;
  font-weight: 900;
}

.hero-subtitle {
  color: var(--text-muted);
  font-size: 1.15rem;
  line-height: 1.7;
  margin-bottom: 2rem;
  max-width: 580px;
}

.hero-badges-row {
  display: flex;
  gap: 1.5rem;
  margin-bottom: 2.5rem;
  flex-wrap: wrap;
}

.badge-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid var(--border-bento);
  padding: 0.75rem 1.25rem;
  border-radius: var(--radius-bento-small);
}

.badge-icon {
  font-size: 1.5rem;
}

.badge-item strong {
  display: block;
  font-size: 0.9rem;
  color: #ffffff;
}

.badge-item p {
  font-size: 0.75rem;
  color: var(--text-muted);
  margin: 0;
}

.hero-cta-group {
  display: flex;
  gap: 1rem;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 2rem;
}

.hero-btn {
  padding: 0.85rem 1.75rem;
  font-size: 0.95rem;
  border-radius: 50px;
  white-space: nowrap;
}

.hero-btn-secondary {
  padding: 0.85rem 1.75rem;
  font-size: 0.95rem;
  border-radius: 50px;
  white-space: nowrap;
}

/* Trust Badges in Hero */
.hero-trust-badges {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  flex-wrap: wrap;
}

.trust-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.trust-number {
  font-size: 1.6rem;
  font-weight: 900;
  color: var(--color-amber);
  line-height: 1.2;
}

.trust-label {
  font-size: 0.85rem;
  color: var(--text-muted);
  font-weight: 500;
  white-space: nowrap;
}

.trust-divider {
  width: 1px;
  height: 36px;
  background: rgba(255, 255, 255, 0.15);
}

@media (max-width: 640px) {
  .hero-cta-group {
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    gap: 0.75rem;
  }

  .hero-btn,
  .hero-btn-secondary {
    width: 100%;
    text-align: center;
    justify-content: center;
    font-size: 0.95rem;
    padding: 0.9rem 1.25rem;
  }

  .hero-trust-badges {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0.75rem;
    text-align: center;
    margin-top: 1.25rem;
    padding-top: 1.25rem;
  }

  .trust-divider {
    display: none;
  }

  .trust-item {
    align-items: center;
  }

  .trust-number {
    font-size: 1.25rem;
  }

  .trust-label {
    font-size: 0.72rem;
    white-space: normal;
    line-height: 1.3;
  }
}

/* Calculator Card */
.hero-calculator-card {
  background: rgba(15, 23, 42, 0.85);
  backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);
  padding: 2rem;
  border-radius: 20px;
  width: 100%;
  box-sizing: border-box;
}

@media (max-width: 640px) {
  .hero-calculator-card {
    padding: 1.25rem;
    border-radius: 16px;
  }
}

.calculator-header {
  margin-bottom: 1.5rem;
}

.calculator-header h3 {
  font-size: 1.35rem;
  font-weight: 800;
  color: #ffffff;
  margin: 0.35rem 0 0.25rem;
}

.calculator-header p {
  font-size: 0.85rem;
  color: var(--text-muted);
  margin: 0;
}

.calc-eyebrow {
  display: block;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  color: var(--color-amber);
  background: transparent;
  border: none;
  padding: 0;
  margin-bottom: 0.35rem;
  text-transform: uppercase;
}

.calc-label {
  display: block;
  font-size: 0.88rem;
  color: #cbd5e1;
  font-weight: 600;
  margin-bottom: 0.4rem;
}

.calc-select {
  width: 100%;
  padding: 0.75rem 1rem;
  background: rgba(11, 15, 23, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 10px;
  color: #ffffff;
  font-size: 0.92rem;
  font-family: inherit;
  outline: none;
  cursor: pointer;
  transition: all 0.2s ease;
  box-sizing: border-box;
}

.calc-select:focus {
  border-color: rgba(245, 158, 11, 0.5);
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.15);
}

.calc-toggle-buttons {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.5rem;
  margin-top: 0.35rem;
}

@media (max-width: 480px) {
  .calc-toggle-buttons {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }
}

.calc-btn {
  background: rgba(11, 15, 23, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #94a3b8;
  padding: 0.65rem 0.4rem;
  border-radius: 8px;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;
  box-sizing: border-box;
}

.calc-btn:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
  border-color: rgba(255, 255, 255, 0.2);
}

.calc-btn.active {
  background: var(--color-amber);
  color: #0F172A;
  border-color: var(--color-amber);
  font-weight: 700;
}

.calc-checkbox-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.65rem 0.9rem;
  background: rgba(11, 15, 23, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
}

.calc-checkbox {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: var(--color-amber);
}

.calc-result-box {
  background: rgba(11, 15, 23, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 1.1rem 1.25rem;
  margin: 1.25rem 0 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  box-sizing: border-box;
}

.result-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.9rem;
  color: #94a3b8;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.result-amount {
  font-size: 1.3rem;
  font-weight: 800;
  color: var(--color-amber);
}

.result-speed {
  font-size: 1.05rem;
  font-weight: 700;
  color: #38BDF8;
}

.calc-slider-group {
  margin-bottom: 1.5rem;
}

.slider-label-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
}

.slider-label-row label {
  color: var(--text-muted);
  font-size: 0.9rem;
  font-weight: 600;
}

.amount-display,
.tenure-display {
  font-size: 1.25rem;
  font-weight: 800;
  color: #ffffff;
  background: rgba(245, 158, 11, 0.15);
  padding: 0.25rem 0.75rem;
  border-radius: var(--radius-bento-small);
  border: 1px solid rgba(245, 158, 11, 0.3);
}

.custom-range-slider {
  appearance: none;
  width: 100%;
  height: 8px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.1);
  outline: none;
  cursor: pointer;
}

.custom-range-slider::-webkit-slider-thumb {
  appearance: none;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: var(--grad-primary);
  cursor: pointer;
  box-shadow: 0 0 15px rgba(245, 158, 11, 0.8);
  border: 2px solid #ffffff;
}

.range-min-max {
  display: flex;
  justify-content: space-between;
  font-size: 0.8rem;
  color: #64748b;
  margin-top: 0.4rem;
}

.tenure-pills {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 0.5rem;
}

.tenure-pill {
  background: rgba(15, 23, 42, 0.8);
  border: 1px solid var(--border-bento);
  color: var(--text-muted);
  font-weight: 700;
  padding: 0.5rem 0;
  border-radius: var(--radius-bento-small);
  cursor: pointer;
  transition: all 0.2s ease;
}

.tenure-pill:hover,
.tenure-pill.active {
  background: var(--color-amber);
  color: #0F172A;
  border-color: var(--color-amber);
}

.calc-summary-box {
  background: rgba(11, 15, 23, 0.8);
  border: 1px solid var(--border-bento);
  border-radius: var(--radius-bento-small);
  padding: 1.25rem;
  margin-bottom: 1.5rem;
}

.main-emi {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.main-emi span {
  color: var(--text-muted);
  font-size: 0.95rem;
  font-weight: 600;
}

.main-emi strong {
  font-size: 1.75rem;
  font-weight: 900;
  color: #FBBF24;
}

.main-emi small {
  font-size: 0.85rem;
  color: var(--text-muted);
}

.summary-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.08);
  margin: 1rem 0;
}

.summary-grid-small {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.75rem;
  text-align: center;
}

.summary-grid-small span {
  display: block;
  font-size: 0.75rem;
  color: var(--text-muted);
  margin-bottom: 0.25rem;
}

.summary-grid-small strong {
  font-size: 0.95rem;
  color: #ffffff;
}

/* ===== Stats Bar ===== */
.fintech-stats-bar {
  padding: 2.5rem 0;
  background: rgba(15, 23, 42, 0.5);
  border-top: 1px solid var(--border-bento);
  border-bottom: 1px solid var(--border-bento);
  margin-bottom: 5rem;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
  text-align: center;
}

@media (max-width: 768px) {
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
  }
}

.stat-number {
  font-size: clamp(2rem, 3vw, 2.75rem);
  font-weight: 900;
  background: var(--grad-primary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 0.25rem;
}

.stat-label {
  color: var(--text-muted);
  font-size: 0.9rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

/* ===== Products Section ===== */
.fintech-products-section {
  padding: 2rem 0 5rem;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
  width: 100%;
}

@media (min-width: 1200px) {
  .products-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

.product-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 1.85rem 1.6rem;
  background: rgba(18, 24, 38, 0.8) !important;
  border: 1px solid rgba(255, 255, 255, 0.09) !important;
  border-radius: 18px !important;
  box-sizing: border-box;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1) !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25) !important;
}

.product-card:hover {
  transform: translateY(-4px) !important;
  border-color: rgba(245, 158, 11, 0.4) !important;
  box-shadow: 0 12px 30px -8px rgba(0, 0, 0, 0.5), 0 0 20px rgba(245, 158, 11, 0.15) !important;
  background: rgba(22, 30, 48, 0.9) !important;
}

.product-top-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.25rem;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.product-icon {
  font-size: 1.5rem;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  line-height: 1;
}

.product-badge {
  font-size: 0.68rem;
  font-weight: 700;
  color: #f59e0b;
  background: rgba(245, 158, 11, 0.1);
  border: 1px solid rgba(245, 158, 11, 0.25);
  padding: 0.3rem 0.75rem;
  border-radius: 20px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  white-space: nowrap;
}

.product-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 0.75rem;
  line-height: 1.35;
  letter-spacing: -0.01em;
  word-break: break-word;
}

.product-desc {
  color: #94a3b8;
  font-size: 0.9rem;
  line-height: 1.6;
  margin-bottom: 1.25rem;
  flex: 1 1;
}

.product-checklist {
  list-style: none;
  padding: 1rem 0;
  margin: 0 0 1.5rem 0;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background: transparent !important;
  border-radius: 0 !important;
  box-sizing: border-box;
}

.product-checklist li {
  font-size: 0.88rem;
  color: #cbd5e1;
  line-height: 1.45;
  display: flex;
  align-items: flex-start;
  gap: 0.55rem;
}

.product-checklist .check-icon {
  color: #f59e0b;
  font-weight: 800;
  font-size: 0.92rem;
  line-height: 1.2;
  flex-shrink: 0;
}

.product-apply-btn {
  width: 100%;
  text-align: center;
  justify-content: center;
  padding: 0.8rem 1.25rem;
  font-size: 0.9rem;
  font-weight: 700;
  color: #0f172a !important;
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%) !important;
  border: none !important;
  border-radius: 12px !important;
  white-space: nowrap;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  line-height: 1.2;
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 4px 14px rgba(245, 158, 11, 0.2) !important;
}

.product-apply-btn:hover {
  background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%) !important;
  box-shadow: 0 6px 20px rgba(245, 158, 11, 0.35) !important;
  transform: translateY(-2px) !important;
}

/* ===== Process Section ===== */
.fintech-process-section {
  padding: 3rem 0 5rem;
}

.process-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1.5rem;
  width: 100%;
}

@media (max-width: 600px) {
  .process-grid {
    grid-template-columns: 1fr;
    gap: 1.25rem;
  }
}

.process-card {
  text-align: center;
  position: relative;
  box-sizing: border-box;
}

.process-num {
  font-size: 3rem;
  font-weight: 900;
  background: var(--grad-gold);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 1rem;
}

.process-title {
  font-size: 1.35rem;
  margin-bottom: 0.75rem;
}

.process-desc {
  color: var(--text-muted);
  font-size: 0.95rem;
  line-height: 1.6;
}

/* ===== Tech Stack Showcase ===== */
.tech-stack-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
  width: 100%;
}

@media (max-width: 960px) {
  .tech-stack-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.25rem;
  }
}

@media (max-width: 600px) {
  .tech-stack-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
}

.tech-stack-card {
  padding: 1.5rem;
  border-radius: 16px;
  background: rgba(15, 23, 42, 0.75);
  border: 1px solid rgba(245, 158, 11, 0.2);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
  transition: all 0.25s ease;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.tech-stack-card:hover {
  transform: translateY(-3px);
  border-color: rgba(245, 158, 11, 0.5);
  background: rgba(20, 28, 48, 0.85);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.35), 0 0 15px rgba(245, 158, 11, 0.15);
}

.tech-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.85rem;
  gap: 0.5rem;
}

.tech-card-icon {
  font-size: 1.75rem;
  line-height: 1;
}

.tech-card-category {
  font-size: 0.72rem;
  font-weight: 800;
  color: var(--color-amber);
  background: rgba(245, 158, 11, 0.12);
  border: 1px solid rgba(245, 158, 11, 0.3);
  padding: 0.2rem 0.65rem;
  border-radius: 50px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  white-space: nowrap;
}

.tech-card-name {
  font-size: 1.15rem;
  font-weight: 800;
  color: #ffffff;
  margin-bottom: 0.4rem;
  line-height: 1.35;
  word-break: break-word;
}

.tech-card-desc {
  font-size: 0.88rem;
  color: #94a3b8;
  line-height: 1.55;
  margin: 0;
}

/* ===== Eligibility Section ===== */
.fintech-eligibility-section {
  padding: 2rem 0 5rem;
}

.eligibility-bento-card {
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  gap: 3rem;
  align-items: center;
}

@media (max-width: 900px) {
  .eligibility-bento-card {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
}

.eligibility-content h2 {
  font-size: 2rem;
  margin-bottom: 0.75rem;
}

.eligibility-content p {
  color: var(--text-muted);
  margin-bottom: 2rem;
}

.eligibility-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1.25rem;
  width: 100%;
}

@media (max-width: 600px) {
  .eligibility-grid {
    grid-template-columns: 1fr;
  }
}

.eligibility-item {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
  background: rgba(11, 15, 23, 0.5);
  border: 1px solid var(--border-bento);
  padding: 1rem;
  border-radius: var(--radius-bento-small);
}

.elig-icon {
  font-size: 1.75rem;
}

.eligibility-item h4 {
  font-size: 1rem;
  margin-bottom: 0.25rem;
}

.eligibility-item p {
  font-size: 0.85rem;
  color: var(--text-muted);
  margin: 0;
}

.eligibility-cta-box {
  background: rgba(245, 158, 11, 0.08);
  border: 1px solid rgba(245, 158, 11, 0.3);
  border-radius: var(--radius-bento-inner);
  padding: 2.5rem 2rem;
  text-align: center;
}

.eligibility-cta-box h3 {
  font-size: 1.4rem;
  margin-bottom: 0.75rem;
}

.eligibility-cta-box p {
  color: var(--text-muted);
  font-size: 0.95rem;
  margin-bottom: 1.5rem;
}

/* ===== Testimonials ===== */
.fintech-testimonials-section {
  padding: 2.5rem 0 5rem;
}

.testimonial-box {
  max-width: 820px;
  margin: 0 auto;
  text-align: center;
  padding: 3rem 2.5rem 2.5rem;
  background: rgba(15, 23, 42, 0.85);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  box-shadow: 0 20px 45px rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(12px);
}

.quote-mark {
  font-size: 3.5rem;
  line-height: 1;
  font-family: Georgia, serif;
  color: var(--color-amber);
  opacity: 0.85;
  margin-bottom: 0.75rem;
  -webkit-user-select: none;
          user-select: none;
}

.testimonial-text {
  font-size: 1.18rem;
  line-height: 1.75;
  color: #f1f5f9;
  font-weight: 400;
  font-style: italic;
  margin-bottom: 2rem;
  max-width: 720px;
  margin-left: auto;
  margin-right: auto;
}

.testimonial-author-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 2rem;
  text-align: left;
}

.author-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: linear-gradient(135deg, #f59e0b 0%, #ea580c 100%);
  color: #000000;
  font-weight: 800;
  font-size: 1.15rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.3);
  flex-shrink: 0;
}

.testimonial-author-info h4 {
  font-size: 1.05rem;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 0.2rem 0;
}

.testimonial-author-info p {
  font-size: 0.85rem;
  color: var(--color-amber);
  margin: 0;
  font-weight: 500;
}

.testimonial-dots {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.6rem;
  margin-top: 0.5rem;
}

.testimonial-dots .dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 0;
}

.testimonial-dots .dot.active {
  background: var(--color-amber);
  width: 26px;
  border-radius: 6px;
  box-shadow: 0 0 10px rgba(245, 158, 11, 0.4);
}

/* ===== FAQ Accordion ===== */
.fintech-faq-section {
  padding: 2rem 0 5rem;
}

.faq-accordion,
.faq-accordion-list {
  max-width: 850px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.faq-item.bento-box {
  border-radius: 14px;
  padding: 1.25rem 1.75rem;
  background: rgba(15, 23, 42, 0.75);
  border: 1px solid rgba(245, 158, 11, 0.2);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  transition: all 0.25 ease;
  cursor: pointer;
  overflow: hidden;
}

.faq-item.bento-box:hover {
  transform: translateY(-2px);
  border-color: rgba(245, 158, 11, 0.45);
  background: rgba(20, 28, 48, 0.85);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3), 0 0 12px rgba(245, 158, 11, 0.12);
}

.faq-item.bento-box.open {
  border-color: rgba(245, 158, 11, 0.55);
  background: rgba(22, 32, 54, 0.95);
}

.faq-question {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  -webkit-user-select: none;
          user-select: none;
}

.faq-question h3 {
  font-size: 1.05rem;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
  line-height: 1.45;
}

.faq-toggle {
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--color-amber);
  background: rgba(245, 158, 11, 0.12);
  border: 1px solid rgba(245, 158, 11, 0.3);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.2s ease;
}

.faq-item:hover .faq-toggle {
  background: var(--color-amber);
  color: #0F172A;
  border-color: var(--color-amber);
}

.faq-answer {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  animation: faqFadeIn 0.25s ease;
}

@keyframes faqFadeIn {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.faq-answer p {
  color: #cbd5e1;
  font-size: 0.95rem;
  line-height: 1.65;
  margin: 0;
}

@media (max-width: 640px) {
  .faq-item.bento-box {
    padding: 1rem 1.25rem;
    border-radius: 12px;
  }

  .faq-question h3 {
    font-size: 0.98rem;
  }

  .faq-toggle {
    width: 28px;
    height: 28px;
    font-size: 1.05rem;
  }
}

/* ===== CTA Banner ===== */
.fintech-cta-banner {
  padding: 3rem 0 6rem;
}

.cta-inner.bento-box {
  text-align: center;
  padding: 3.5rem 2.5rem;
  background: radial-gradient(circle at 50% 30%, rgba(245, 158, 11, 0.16) 0%, rgba(15, 23, 42, 0.96) 75%);
  border: 1px solid rgba(245, 158, 11, 0.35);
  border-radius: 24px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5), 0 0 30px rgba(245, 158, 11, 0.12);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.cta-eyebrow {
  margin-bottom: 0.85rem;
}

.cta-inner h2 {
  font-size: clamp(1.8rem, 3.5vw, 2.6rem);
  font-weight: 800;
  color: #ffffff;
  max-width: 800px;
  margin: 0 auto 1rem;
  line-height: 1.25;
  letter-spacing: -0.02em;
}

.cta-subtitle {
  color: #cbd5e1;
  font-size: 1.05rem;
  max-width: 680px;
  margin: 0 auto 1.75rem;
  line-height: 1.6;
}

.cta-subtitle strong {
  color: #ffffff;
  font-weight: 700;
}

.cta-trust-badges {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.75rem 1.25rem;
  margin-bottom: 2.25rem;
}

.cta-trust-badges span {
  font-size: 0.82rem;
  font-weight: 700;
  color: var(--color-amber);
  background: rgba(245, 158, 11, 0.1);
  border: 1px solid rgba(245, 158, 11, 0.25);
  padding: 0.35rem 0.85rem;
  border-radius: 50px;
  letter-spacing: 0.02em;
}

.cta-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.cta-btn-primary {
  padding: 0.85rem 2rem;
  font-size: 0.95rem;
  font-weight: 800;
  border-radius: 50px;
  white-space: nowrap;
  box-shadow: 0 4px 20px rgba(245, 158, 11, 0.35);
}

.cta-btn-secondary {
  padding: 0.85rem 1.75rem;
  font-size: 0.95rem;
  font-weight: 700;
  border-radius: 50px;
  background: rgba(30, 41, 59, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #ffffff;
  white-space: nowrap;
  transition: all 0.25s ease;
}

.cta-btn-secondary:hover {
  background: rgba(51, 65, 85, 0.9);
  border-color: rgba(245, 158, 11, 0.5);
  color: var(--color-amber);
  transform: translateY(-2px);
}

@media (max-width: 640px) {
  .cta-inner.bento-box {
    padding: 2.25rem 1.25rem;
    border-radius: 18px;
  }

  .cta-trust-badges {
    gap: 0.5rem;
    margin-bottom: 1.75rem;
  }

  .cta-trust-badges span {
    font-size: 0.78rem;
    padding: 0.25rem 0.65rem;
  }

  .cta-actions {
    flex-direction: column;
    width: 100%;
  }

  .cta-btn-primary,
  .cta-btn-secondary {
    width: 100%;
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Home.css"],"names":[],"mappings":"AAAA;;+CAE+C;;AAE/C;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,+CAA+C;AAC/C;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gFAAgF;EAChF,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iFAAiF;EACjF,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;IAC1B,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iCAAiC;EACjC,qCAAqC;EACrC,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;EAClB;AACF;;AAEA,oBAAoB;AACpB;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,2CAA2C;EAC3C,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,iCAAiC;EACjC,2CAA2C;EAC3C,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;IAC1B,WAAW;EACb;AACF;;AAEA;EACE,iCAAiC;EACjC,0CAA0C;EAC1C,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,2CAA2C;EAC3C,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,wBAAwB;EACxB,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,eAAe;AACjB;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;EACjB,wCAAwC;EACxC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,8BAA8B;EAC9B,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,wCAAwC;EACxC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,iBAAiB;EACjB,iCAAiC;EACjC,yCAAyC;EACzC,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,qCAAqC;IACrC,WAAW;EACb;AACF;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,+BAA+B;EAC/B,6BAA6B;EAC7B,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,iCAAiC;AACjC;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,WAAW;AACb;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,uBAAuB;EACvB,4CAA4C;EAC5C,sDAAsD;EACtD,8BAA8B;EAC9B,sBAAsB;EACtB,6DAA6D;EAC7D,qDAAqD;AACvD;;AAEA;EACE,sCAAsC;EACtC,gDAAgD;EAChD,6FAA6F;EAC7F,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,0CAA0C;EAC1C,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,+CAA+C;EAC/C,kDAAkD;EAClD,kCAAkC;EAClC,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,wEAAwE;EACxE,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,yDAAyD;AAC3D;;AAEA;EACE,wEAAwE;EACxE,0DAA0D;EAC1D,sCAAsC;AACxC;;AAEA,gCAAgC;AAChC;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,WAAW;AACb;;AAEA;EACE;IACE,0BAA0B;IAC1B,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;EAC7B,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,WAAW;AACb;;AAEA;EACE;IACE,qCAAqC;IACrC,YAAY;EACd;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kCAAkC;EAClC,yCAAyC;EACzC,0CAA0C;EAC1C,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,kCAAkC;EAClC,6EAA6E;AAC/E;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,oCAAoC;EACpC,yCAAyC;EACzC,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;;AAEA,oCAAoC;AACpC;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;EACZ,WAAW;AACb;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,iCAAiC;EACjC,qCAAqC;EACrC,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,wCAAwC;EACxC,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,6BAA6B;AAC7B;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,2BAA2B;EAC3B,kCAAkC;EAClC,2CAA2C;EAC3C,mBAAmB;EACnB,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,2BAA2B;EAC3B,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA,8BAA8B;AAC9B;EACE,oBAAoB;AACtB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,kCAAkC;EAClC,yCAAyC;EACzC,yCAAyC;EACzC,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,kCAAkC;EAClC,4EAA4E;AAC9E;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,oCAAoC;EACpC,yCAAyC;EACzC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;EAC9C,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE;IACE,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;AACF;;AAEA,2BAA2B;AAC3B;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,uGAAuG;EACvG,0CAA0C;EAC1C,mBAAmB;EACnB,6EAA6E;EAC7E,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mCAAmC;EACnC,0CAA0C;EAC1C,wBAAwB;EACxB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;EACjC,0CAA0C;EAC1C,cAAc;EACd,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE;IACE,wBAAwB;IACxB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;;IAEE,WAAW;IACX,uBAAuB;EACzB;AACF","sourcesContent":["/* ==========================================\n   Kubersetu Infotech - Homepage Layout & Components\n   ========================================== */\n\n.fintech-home {\n  width: 100%;\n  padding-top: 5rem;\n  overflow-x: hidden;\n}\n\n.fintech-container {\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 0 1.5rem;\n}\n\n.w-full {\n  width: 100%;\n}\n\n.text-amber {\n  color: var(--color-amber) !important;\n}\n\n/* ===== Section Header Common ===== */\n.section-header-center {\n  text-align: center;\n  max-width: 700px;\n  margin: 0 auto 3.5rem;\n}\n\n.section-eyebrow {\n  display: inline-block;\n  font-size: 0.85rem;\n  font-weight: 800;\n  letter-spacing: 0.15em;\n  color: var(--color-amber);\n  background: transparent;\n  border: none;\n  padding: 0.2rem 0;\n  margin-bottom: 1rem;\n  text-transform: uppercase;\n}\n\n.section-header-center h2 {\n  font-size: clamp(2rem, 3.5vw, 2.75rem);\n  margin-bottom: 1rem;\n  font-weight: 800;\n}\n\n.section-header-center p {\n  color: var(--text-muted);\n  font-size: 1.1rem;\n  line-height: 1.6;\n}\n\n/* ===== Hero Section & Live Calculator ===== */\n.hero-background-shapes {\n  position: absolute;\n  inset: 0;\n  overflow: hidden;\n  z-index: 0;\n  pointer-events: none;\n}\n\n.glow-orb {\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(120px);\n  opacity: 0.4;\n}\n\n.hero-background-shapes .orb-1 {\n  width: 600px;\n  height: 600px;\n  background: radial-gradient(circle, rgba(245, 158, 11, 0.2) 0%, transparent 70%);\n  top: -20%;\n  left: -10%;\n}\n\n.hero-background-shapes .orb-2 {\n  width: 500px;\n  height: 500px;\n  background: radial-gradient(circle, rgba(59, 130, 246, 0.15) 0%, transparent 70%);\n  bottom: 10%;\n  right: -5%;\n}\n\n.fintech-hero {\n  padding: 0 0 5rem;\n  position: relative;\n}\n\n.hero-grid {\n  display: grid;\n  grid-template-columns: 1.1fr 0.9fr;\n  gap: 3rem;\n  align-items: center;\n}\n\n@media (max-width: 1024px) {\n  .hero-grid {\n    grid-template-columns: 1fr;\n    gap: 2.5rem;\n  }\n}\n\n.hero-content {\n  display: flex;\n  flex-direction: column;\n}\n\n.trust-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.6rem;\n  background: transparent;\n  border: none;\n  padding: 0.2rem 0;\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: #FBBF24;\n  margin-bottom: 1.5rem;\n  width: fit-content;\n}\n\n.pill-dot {\n  width: 8px;\n  height: 8px;\n  background: #10B981;\n  border-radius: 50%;\n  box-shadow: 0 0 10px #10B981;\n}\n\n.hero-title {\n  font-size: clamp(2.5rem, 4.5vw, 3.75rem);\n  line-height: 1.15;\n  margin-bottom: 1.25rem;\n  font-weight: 900;\n}\n\n.hero-subtitle {\n  color: var(--text-muted);\n  font-size: 1.15rem;\n  line-height: 1.7;\n  margin-bottom: 2rem;\n  max-width: 580px;\n}\n\n.hero-badges-row {\n  display: flex;\n  gap: 1.5rem;\n  margin-bottom: 2.5rem;\n  flex-wrap: wrap;\n}\n\n.badge-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  background: rgba(15, 23, 42, 0.6);\n  border: 1px solid var(--border-bento);\n  padding: 0.75rem 1.25rem;\n  border-radius: var(--radius-bento-small);\n}\n\n.badge-icon {\n  font-size: 1.5rem;\n}\n\n.badge-item strong {\n  display: block;\n  font-size: 0.9rem;\n  color: #ffffff;\n}\n\n.badge-item p {\n  font-size: 0.75rem;\n  color: var(--text-muted);\n  margin: 0;\n}\n\n.hero-cta-group {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n  flex-wrap: wrap;\n  margin-bottom: 2rem;\n}\n\n.hero-btn {\n  padding: 0.85rem 1.75rem;\n  font-size: 0.95rem;\n  border-radius: 50px;\n  white-space: nowrap;\n}\n\n.hero-btn-secondary {\n  padding: 0.85rem 1.75rem;\n  font-size: 0.95rem;\n  border-radius: 50px;\n  white-space: nowrap;\n}\n\n/* Trust Badges in Hero */\n.hero-trust-badges {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n  margin-top: 1.5rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  flex-wrap: wrap;\n}\n\n.trust-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.trust-number {\n  font-size: 1.6rem;\n  font-weight: 900;\n  color: var(--color-amber);\n  line-height: 1.2;\n}\n\n.trust-label {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.trust-divider {\n  width: 1px;\n  height: 36px;\n  background: rgba(255, 255, 255, 0.15);\n}\n\n@media (max-width: 640px) {\n  .hero-cta-group {\n    flex-direction: column;\n    align-items: stretch;\n    width: 100%;\n    gap: 0.75rem;\n  }\n\n  .hero-btn,\n  .hero-btn-secondary {\n    width: 100%;\n    text-align: center;\n    justify-content: center;\n    font-size: 0.95rem;\n    padding: 0.9rem 1.25rem;\n  }\n\n  .hero-trust-badges {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 0.75rem;\n    text-align: center;\n    margin-top: 1.25rem;\n    padding-top: 1.25rem;\n  }\n\n  .trust-divider {\n    display: none;\n  }\n\n  .trust-item {\n    align-items: center;\n  }\n\n  .trust-number {\n    font-size: 1.25rem;\n  }\n\n  .trust-label {\n    font-size: 0.72rem;\n    white-space: normal;\n    line-height: 1.3;\n  }\n}\n\n/* Calculator Card */\n.hero-calculator-card {\n  background: rgba(15, 23, 42, 0.85);\n  backdrop-filter: blur(16px);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);\n  padding: 2rem;\n  border-radius: 20px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n@media (max-width: 640px) {\n  .hero-calculator-card {\n    padding: 1.25rem;\n    border-radius: 16px;\n  }\n}\n\n.calculator-header {\n  margin-bottom: 1.5rem;\n}\n\n.calculator-header h3 {\n  font-size: 1.35rem;\n  font-weight: 800;\n  color: #ffffff;\n  margin: 0.35rem 0 0.25rem;\n}\n\n.calculator-header p {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n  margin: 0;\n}\n\n.calc-eyebrow {\n  display: block;\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  color: var(--color-amber);\n  background: transparent;\n  border: none;\n  padding: 0;\n  margin-bottom: 0.35rem;\n  text-transform: uppercase;\n}\n\n.calc-label {\n  display: block;\n  font-size: 0.88rem;\n  color: #cbd5e1;\n  font-weight: 600;\n  margin-bottom: 0.4rem;\n}\n\n.calc-select {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  background: rgba(11, 15, 23, 0.9);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 10px;\n  color: #ffffff;\n  font-size: 0.92rem;\n  font-family: inherit;\n  outline: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-sizing: border-box;\n}\n\n.calc-select:focus {\n  border-color: rgba(245, 158, 11, 0.5);\n  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.15);\n}\n\n.calc-toggle-buttons {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 0.5rem;\n  margin-top: 0.35rem;\n}\n\n@media (max-width: 480px) {\n  .calc-toggle-buttons {\n    grid-template-columns: 1fr;\n    gap: 0.5rem;\n  }\n}\n\n.calc-btn {\n  background: rgba(11, 15, 23, 0.8);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: #94a3b8;\n  padding: 0.65rem 0.4rem;\n  border-radius: 8px;\n  font-size: 0.82rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: center;\n  box-sizing: border-box;\n}\n\n.calc-btn:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #ffffff;\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n.calc-btn.active {\n  background: var(--color-amber);\n  color: #0F172A;\n  border-color: var(--color-amber);\n  font-weight: 700;\n}\n\n.calc-checkbox-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.65rem 0.9rem;\n  background: rgba(11, 15, 23, 0.6);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 10px;\n}\n\n.calc-checkbox {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  accent-color: var(--color-amber);\n}\n\n.calc-result-box {\n  background: rgba(11, 15, 23, 0.9);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n  padding: 1.1rem 1.25rem;\n  margin: 1.25rem 0 1.25rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n  box-sizing: border-box;\n}\n\n.result-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.9rem;\n  color: #94a3b8;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.result-amount {\n  font-size: 1.3rem;\n  font-weight: 800;\n  color: var(--color-amber);\n}\n\n.result-speed {\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: #38BDF8;\n}\n\n.calc-slider-group {\n  margin-bottom: 1.5rem;\n}\n\n.slider-label-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.75rem;\n}\n\n.slider-label-row label {\n  color: var(--text-muted);\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n\n.amount-display,\n.tenure-display {\n  font-size: 1.25rem;\n  font-weight: 800;\n  color: #ffffff;\n  background: rgba(245, 158, 11, 0.15);\n  padding: 0.25rem 0.75rem;\n  border-radius: var(--radius-bento-small);\n  border: 1px solid rgba(245, 158, 11, 0.3);\n}\n\n.custom-range-slider {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 100%;\n  height: 8px;\n  border-radius: 4px;\n  background: rgba(255, 255, 255, 0.1);\n  outline: none;\n  cursor: pointer;\n}\n\n.custom-range-slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: var(--grad-primary);\n  cursor: pointer;\n  box-shadow: 0 0 15px rgba(245, 158, 11, 0.8);\n  border: 2px solid #ffffff;\n}\n\n.range-min-max {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.8rem;\n  color: #64748b;\n  margin-top: 0.4rem;\n}\n\n.tenure-pills {\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  gap: 0.5rem;\n}\n\n.tenure-pill {\n  background: rgba(15, 23, 42, 0.8);\n  border: 1px solid var(--border-bento);\n  color: var(--text-muted);\n  font-weight: 700;\n  padding: 0.5rem 0;\n  border-radius: var(--radius-bento-small);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.tenure-pill:hover,\n.tenure-pill.active {\n  background: var(--color-amber);\n  color: #0F172A;\n  border-color: var(--color-amber);\n}\n\n.calc-summary-box {\n  background: rgba(11, 15, 23, 0.8);\n  border: 1px solid var(--border-bento);\n  border-radius: var(--radius-bento-small);\n  padding: 1.25rem;\n  margin-bottom: 1.5rem;\n}\n\n.main-emi {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.main-emi span {\n  color: var(--text-muted);\n  font-size: 0.95rem;\n  font-weight: 600;\n}\n\n.main-emi strong {\n  font-size: 1.75rem;\n  font-weight: 900;\n  color: #FBBF24;\n}\n\n.main-emi small {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n}\n\n.summary-divider {\n  height: 1px;\n  background: rgba(255, 255, 255, 0.08);\n  margin: 1rem 0;\n}\n\n.summary-grid-small {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 0.75rem;\n  text-align: center;\n}\n\n.summary-grid-small span {\n  display: block;\n  font-size: 0.75rem;\n  color: var(--text-muted);\n  margin-bottom: 0.25rem;\n}\n\n.summary-grid-small strong {\n  font-size: 0.95rem;\n  color: #ffffff;\n}\n\n/* ===== Stats Bar ===== */\n.fintech-stats-bar {\n  padding: 2.5rem 0;\n  background: rgba(15, 23, 42, 0.5);\n  border-top: 1px solid var(--border-bento);\n  border-bottom: 1px solid var(--border-bento);\n  margin-bottom: 5rem;\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 2rem;\n  text-align: center;\n}\n\n@media (max-width: 768px) {\n  .stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 1.5rem;\n  }\n}\n\n.stat-number {\n  font-size: clamp(2rem, 3vw, 2.75rem);\n  font-weight: 900;\n  background: var(--grad-primary);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  margin-bottom: 0.25rem;\n}\n\n.stat-label {\n  color: var(--text-muted);\n  font-size: 0.9rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n/* ===== Products Section ===== */\n.fintech-products-section {\n  padding: 2rem 0 5rem;\n}\n\n.products-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 1.5rem;\n  width: 100%;\n}\n\n@media (min-width: 1200px) {\n  .products-grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n.product-card {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n  padding: 1.85rem 1.6rem;\n  background: rgba(18, 24, 38, 0.8) !important;\n  border: 1px solid rgba(255, 255, 255, 0.09) !important;\n  border-radius: 18px !important;\n  box-sizing: border-box;\n  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1) !important;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25) !important;\n}\n\n.product-card:hover {\n  transform: translateY(-4px) !important;\n  border-color: rgba(245, 158, 11, 0.4) !important;\n  box-shadow: 0 12px 30px -8px rgba(0, 0, 0, 0.5), 0 0 20px rgba(245, 158, 11, 0.15) !important;\n  background: rgba(22, 30, 48, 0.9) !important;\n}\n\n.product-top-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.25rem;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.product-icon {\n  font-size: 1.5rem;\n  width: 44px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n  line-height: 1;\n}\n\n.product-badge {\n  font-size: 0.68rem;\n  font-weight: 700;\n  color: #f59e0b;\n  background: rgba(245, 158, 11, 0.1);\n  border: 1px solid rgba(245, 158, 11, 0.25);\n  padding: 0.3rem 0.75rem;\n  border-radius: 20px;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.product-title {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #ffffff;\n  margin-bottom: 0.75rem;\n  line-height: 1.35;\n  letter-spacing: -0.01em;\n  word-break: break-word;\n}\n\n.product-desc {\n  color: #94a3b8;\n  font-size: 0.9rem;\n  line-height: 1.6;\n  margin-bottom: 1.25rem;\n  flex: 1;\n}\n\n.product-checklist {\n  list-style: none;\n  padding: 1rem 0;\n  margin: 0 0 1.5rem 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  background: transparent !important;\n  border-radius: 0 !important;\n  box-sizing: border-box;\n}\n\n.product-checklist li {\n  font-size: 0.88rem;\n  color: #cbd5e1;\n  line-height: 1.45;\n  display: flex;\n  align-items: flex-start;\n  gap: 0.55rem;\n}\n\n.product-checklist .check-icon {\n  color: #f59e0b;\n  font-weight: 800;\n  font-size: 0.92rem;\n  line-height: 1.2;\n  flex-shrink: 0;\n}\n\n.product-apply-btn {\n  width: 100%;\n  text-align: center;\n  justify-content: center;\n  padding: 0.8rem 1.25rem;\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: #0f172a !important;\n  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%) !important;\n  border: none !important;\n  border-radius: 12px !important;\n  white-space: nowrap;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  line-height: 1.2;\n  cursor: pointer;\n  transition: all 0.25s ease;\n  box-shadow: 0 4px 14px rgba(245, 158, 11, 0.2) !important;\n}\n\n.product-apply-btn:hover {\n  background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%) !important;\n  box-shadow: 0 6px 20px rgba(245, 158, 11, 0.35) !important;\n  transform: translateY(-2px) !important;\n}\n\n/* ===== Process Section ===== */\n.fintech-process-section {\n  padding: 3rem 0 5rem;\n}\n\n.process-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 1.5rem;\n  width: 100%;\n}\n\n@media (max-width: 600px) {\n  .process-grid {\n    grid-template-columns: 1fr;\n    gap: 1.25rem;\n  }\n}\n\n.process-card {\n  text-align: center;\n  position: relative;\n  box-sizing: border-box;\n}\n\n.process-num {\n  font-size: 3rem;\n  font-weight: 900;\n  background: var(--grad-gold);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  margin-bottom: 1rem;\n}\n\n.process-title {\n  font-size: 1.35rem;\n  margin-bottom: 0.75rem;\n}\n\n.process-desc {\n  color: var(--text-muted);\n  font-size: 0.95rem;\n  line-height: 1.6;\n}\n\n/* ===== Tech Stack Showcase ===== */\n.tech-stack-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1.5rem;\n  width: 100%;\n}\n\n@media (max-width: 960px) {\n  .tech-stack-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 1.25rem;\n  }\n}\n\n@media (max-width: 600px) {\n  .tech-stack-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n}\n\n.tech-stack-card {\n  padding: 1.5rem;\n  border-radius: 16px;\n  background: rgba(15, 23, 42, 0.75);\n  border: 1px solid rgba(245, 158, 11, 0.2);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);\n  transition: all 0.25s ease;\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n}\n\n.tech-stack-card:hover {\n  transform: translateY(-3px);\n  border-color: rgba(245, 158, 11, 0.5);\n  background: rgba(20, 28, 48, 0.85);\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.35), 0 0 15px rgba(245, 158, 11, 0.15);\n}\n\n.tech-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 0.85rem;\n  gap: 0.5rem;\n}\n\n.tech-card-icon {\n  font-size: 1.75rem;\n  line-height: 1;\n}\n\n.tech-card-category {\n  font-size: 0.72rem;\n  font-weight: 800;\n  color: var(--color-amber);\n  background: rgba(245, 158, 11, 0.12);\n  border: 1px solid rgba(245, 158, 11, 0.3);\n  padding: 0.2rem 0.65rem;\n  border-radius: 50px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  white-space: nowrap;\n}\n\n.tech-card-name {\n  font-size: 1.15rem;\n  font-weight: 800;\n  color: #ffffff;\n  margin-bottom: 0.4rem;\n  line-height: 1.35;\n  word-break: break-word;\n}\n\n.tech-card-desc {\n  font-size: 0.88rem;\n  color: #94a3b8;\n  line-height: 1.55;\n  margin: 0;\n}\n\n/* ===== Eligibility Section ===== */\n.fintech-eligibility-section {\n  padding: 2rem 0 5rem;\n}\n\n.eligibility-bento-card {\n  display: grid;\n  grid-template-columns: 1.5fr 1fr;\n  gap: 3rem;\n  align-items: center;\n}\n\n@media (max-width: 900px) {\n  .eligibility-bento-card {\n    grid-template-columns: 1fr;\n    gap: 2rem;\n  }\n}\n\n.eligibility-content h2 {\n  font-size: 2rem;\n  margin-bottom: 0.75rem;\n}\n\n.eligibility-content p {\n  color: var(--text-muted);\n  margin-bottom: 2rem;\n}\n\n.eligibility-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 1.25rem;\n  width: 100%;\n}\n\n@media (max-width: 600px) {\n  .eligibility-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.eligibility-item {\n  display: flex;\n  gap: 1rem;\n  align-items: flex-start;\n  background: rgba(11, 15, 23, 0.5);\n  border: 1px solid var(--border-bento);\n  padding: 1rem;\n  border-radius: var(--radius-bento-small);\n}\n\n.elig-icon {\n  font-size: 1.75rem;\n}\n\n.eligibility-item h4 {\n  font-size: 1rem;\n  margin-bottom: 0.25rem;\n}\n\n.eligibility-item p {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n  margin: 0;\n}\n\n.eligibility-cta-box {\n  background: rgba(245, 158, 11, 0.08);\n  border: 1px solid rgba(245, 158, 11, 0.3);\n  border-radius: var(--radius-bento-inner);\n  padding: 2.5rem 2rem;\n  text-align: center;\n}\n\n.eligibility-cta-box h3 {\n  font-size: 1.4rem;\n  margin-bottom: 0.75rem;\n}\n\n.eligibility-cta-box p {\n  color: var(--text-muted);\n  font-size: 0.95rem;\n  margin-bottom: 1.5rem;\n}\n\n/* ===== Testimonials ===== */\n.fintech-testimonials-section {\n  padding: 2.5rem 0 5rem;\n}\n\n.testimonial-box {\n  max-width: 820px;\n  margin: 0 auto;\n  text-align: center;\n  padding: 3rem 2.5rem 2.5rem;\n  background: rgba(15, 23, 42, 0.85);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 20px;\n  box-shadow: 0 20px 45px rgba(0, 0, 0, 0.4);\n  backdrop-filter: blur(12px);\n}\n\n.quote-mark {\n  font-size: 3.5rem;\n  line-height: 1;\n  font-family: Georgia, serif;\n  color: var(--color-amber);\n  opacity: 0.85;\n  margin-bottom: 0.75rem;\n  user-select: none;\n}\n\n.testimonial-text {\n  font-size: 1.18rem;\n  line-height: 1.75;\n  color: #f1f5f9;\n  font-weight: 400;\n  font-style: italic;\n  margin-bottom: 2rem;\n  max-width: 720px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.testimonial-author-row {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  margin-bottom: 2rem;\n  text-align: left;\n}\n\n.author-avatar {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #f59e0b 0%, #ea580c 100%);\n  color: #000000;\n  font-weight: 800;\n  font-size: 1.15rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.3);\n  flex-shrink: 0;\n}\n\n.testimonial-author-info h4 {\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0 0 0.2rem 0;\n}\n\n.testimonial-author-info p {\n  font-size: 0.85rem;\n  color: var(--color-amber);\n  margin: 0;\n  font-weight: 500;\n}\n\n.testimonial-dots {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.6rem;\n  margin-top: 0.5rem;\n}\n\n.testimonial-dots .dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  padding: 0;\n}\n\n.testimonial-dots .dot.active {\n  background: var(--color-amber);\n  width: 26px;\n  border-radius: 6px;\n  box-shadow: 0 0 10px rgba(245, 158, 11, 0.4);\n}\n\n/* ===== FAQ Accordion ===== */\n.fintech-faq-section {\n  padding: 2rem 0 5rem;\n}\n\n.faq-accordion,\n.faq-accordion-list {\n  max-width: 850px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.faq-item.bento-box {\n  border-radius: 14px;\n  padding: 1.25rem 1.75rem;\n  background: rgba(15, 23, 42, 0.75);\n  border: 1px solid rgba(245, 158, 11, 0.2);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n  transition: all 0.25 ease;\n  cursor: pointer;\n  overflow: hidden;\n}\n\n.faq-item.bento-box:hover {\n  transform: translateY(-2px);\n  border-color: rgba(245, 158, 11, 0.45);\n  background: rgba(20, 28, 48, 0.85);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3), 0 0 12px rgba(245, 158, 11, 0.12);\n}\n\n.faq-item.bento-box.open {\n  border-color: rgba(245, 158, 11, 0.55);\n  background: rgba(22, 32, 54, 0.95);\n}\n\n.faq-question {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n  user-select: none;\n}\n\n.faq-question h3 {\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0;\n  line-height: 1.45;\n}\n\n.faq-toggle {\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: var(--color-amber);\n  background: rgba(245, 158, 11, 0.12);\n  border: 1px solid rgba(245, 158, 11, 0.3);\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: all 0.2s ease;\n}\n\n.faq-item:hover .faq-toggle {\n  background: var(--color-amber);\n  color: #0F172A;\n  border-color: var(--color-amber);\n}\n\n.faq-answer {\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  animation: faqFadeIn 0.25s ease;\n}\n\n@keyframes faqFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.faq-answer p {\n  color: #cbd5e1;\n  font-size: 0.95rem;\n  line-height: 1.65;\n  margin: 0;\n}\n\n@media (max-width: 640px) {\n  .faq-item.bento-box {\n    padding: 1rem 1.25rem;\n    border-radius: 12px;\n  }\n\n  .faq-question h3 {\n    font-size: 0.98rem;\n  }\n\n  .faq-toggle {\n    width: 28px;\n    height: 28px;\n    font-size: 1.05rem;\n  }\n}\n\n/* ===== CTA Banner ===== */\n.fintech-cta-banner {\n  padding: 3rem 0 6rem;\n}\n\n.cta-inner.bento-box {\n  text-align: center;\n  padding: 3.5rem 2.5rem;\n  background: radial-gradient(circle at 50% 30%, rgba(245, 158, 11, 0.16) 0%, rgba(15, 23, 42, 0.96) 75%);\n  border: 1px solid rgba(245, 158, 11, 0.35);\n  border-radius: 24px;\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5), 0 0 30px rgba(245, 158, 11, 0.12);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.cta-eyebrow {\n  margin-bottom: 0.85rem;\n}\n\n.cta-inner h2 {\n  font-size: clamp(1.8rem, 3.5vw, 2.6rem);\n  font-weight: 800;\n  color: #ffffff;\n  max-width: 800px;\n  margin: 0 auto 1rem;\n  line-height: 1.25;\n  letter-spacing: -0.02em;\n}\n\n.cta-subtitle {\n  color: #cbd5e1;\n  font-size: 1.05rem;\n  max-width: 680px;\n  margin: 0 auto 1.75rem;\n  line-height: 1.6;\n}\n\n.cta-subtitle strong {\n  color: #ffffff;\n  font-weight: 700;\n}\n\n.cta-trust-badges {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 0.75rem 1.25rem;\n  margin-bottom: 2.25rem;\n}\n\n.cta-trust-badges span {\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: var(--color-amber);\n  background: rgba(245, 158, 11, 0.1);\n  border: 1px solid rgba(245, 158, 11, 0.25);\n  padding: 0.35rem 0.85rem;\n  border-radius: 50px;\n  letter-spacing: 0.02em;\n}\n\n.cta-actions {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.cta-btn-primary {\n  padding: 0.85rem 2rem;\n  font-size: 0.95rem;\n  font-weight: 800;\n  border-radius: 50px;\n  white-space: nowrap;\n  box-shadow: 0 4px 20px rgba(245, 158, 11, 0.35);\n}\n\n.cta-btn-secondary {\n  padding: 0.85rem 1.75rem;\n  font-size: 0.95rem;\n  font-weight: 700;\n  border-radius: 50px;\n  background: rgba(30, 41, 59, 0.8);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: #ffffff;\n  white-space: nowrap;\n  transition: all 0.25s ease;\n}\n\n.cta-btn-secondary:hover {\n  background: rgba(51, 65, 85, 0.9);\n  border-color: rgba(245, 158, 11, 0.5);\n  color: var(--color-amber);\n  transform: translateY(-2px);\n}\n\n@media (max-width: 640px) {\n  .cta-inner.bento-box {\n    padding: 2.25rem 1.25rem;\n    border-radius: 18px;\n  }\n\n  .cta-trust-badges {\n    gap: 0.5rem;\n    margin-bottom: 1.75rem;\n  }\n\n  .cta-trust-badges span {\n    font-size: 0.78rem;\n    padding: 0.25rem 0.65rem;\n  }\n\n  .cta-actions {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .cta-btn-primary,\n  .cta-btn-secondary {\n    width: 100%;\n    justify-content: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
